<template>
  <div class="auto-fit-container" ref="container" :class="align">
    <div
      class="content-wrapper"
      :class="align"
      :style="{ transform: `scale(${currentScale})` }"
      ref="content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutoFitComponent',
  props: {
    // 可选的自定义类名
    className: {
      type: String,
      default: '',
    },
    // 最小缩放比例限制
    minScale: {
      type: Number,
      default: 0.2,
    },
    // 内容对齐方式
    align: {
      type: String,
      default: 'left',
      validator: (value) => ['left', 'center', 'right'].includes(value),
    },
  },
  data() {
    return {
      currentScale: 1,
    }
  },
  mounted() {
    this.updateScale()
  },
  methods: {
    updateScale() {
      if (!this.$refs.container || !this.$refs.content) return

      const containerWidth = this.$refs.container.offsetWidth
      const contentWidth = this.$refs.content.scrollWidth

      // 如果内容宽度小于容器宽度，使用原始大小
      if (contentWidth <= containerWidth) {
        this.currentScale = 1
        return
      }

      // 计算需要的缩放比例
      const scale = containerWidth / contentWidth

      // 应用最小缩放限制
      this.currentScale = Math.max(scale, this.minScale)
    },
  },
  watch: {
    // 监听可能影响内容宽度的变化
    $route() {
      this.$nextTick(this.updateScale)
    },
  },
}
</script>

<style scoped>
.auto-fit-container {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  display: flex;
}
.auto-fit-container.center {
  justify-content: center;
}

.content-wrapper {
  display: inline-block;
  transform-origin: left center;
  transform: scale(1);
}
.content-wrapper.left {
  text-align: left;
}
.content-wrapper.center {
  text-align: center;
  transform-origin: center center;
}
.content-wrapper.right {
  text-align: right;
  transform-origin: right center;
}
</style>
